import { render, staticRenderFns } from "./dashboard-ocaa.vue?vue&type=template&id=6cc0ba70&"
import script from "./dashboard-ocaa.vue?vue&type=script&lang=js&"
export * from "./dashboard-ocaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports